var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"organization-read__payment-gateway"},[_c('div',{staticClass:"payment-cards"},_vm._l((_vm.paymentMethodsCards),function(card){return _c('payment-card-view',{key:card.title,attrs:{"title":card.title,"features":card.features,"odds":card.odds}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }